<template>
  <v-navigation-drawer
    :width="240"
    :permanent="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs"
    dark
    app
    class="rounded-0"
    v-model="$store.state.sidebar.open"
    :mini-variant.sync="$store.state.sidebar.mini"
    :expand-on-hover="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs && $store.state.sidebar.expand_on_hover"
  >
    <v-card @mouseenter="handleExpandMenu(true)" @mouseleave="handleExpandMenu(false)" style="min-height: 100vh" width="240">
      <div>
        <v-list style="height: 100px" v-show="!$store.state.sidebar.mini">
          <v-list-item>
            <v-list-item-content class="pt-1" style="display: flex; justify-content: center">
              <v-img transition="fade-transition" :src="require('@/assets/images/syscore_logo.svg')" contain style="max-width: 100%; margin-top: 14px" class="pt-0" />
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div style="height: 100px" v-show="$store.state.sidebar.mini" class="pt-3">
          <v-img transition="fade-transition" :src="require('@/assets/images/syscore_logo_mini.svg')" contain height="80" width="80%" style="margin: 0 auto" class="pt-8" />
        </div>
        <v-divider class="mt-0"></v-divider>
      </div>

      <div style="scroll-margin-top: 100px" v-for="item in items" :key="item.title">
        <v-list v-if="item.visible" dense nav>
          <v-list-group v-if="item.visible && 'items' in item && item.items.length > 0" v-model="item.active" :key="item.title" no-action>
            <v-list-item slot="activator">
              <v-list-item-icon>
                <font-awesome-icon :icon="item.icon" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <router-link v-for="subItem in item.items" :key="subItem.title" :to="'/' + subItem.path">
              <v-list-item v-if="subItem.visible" ripple @click="close" class="subitem">
                <!--<v-list-item-icon>
                  <font-awesome-icon :icon="subItem.icon" />
                </v-list-item-icon>-->
                <v-list-item-content class="pl-6">
                  <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </router-link>
          </v-list-group>

          <router-link v-else-if="item.visible" :to="'/' + item.path">
            <v-list-item :key="item.title" link>
              <v-list-item-icon>
                <font-awesome-icon :icon="item.icon" />
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list>
      </div>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import Constant from "@/constants/sections";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import { cryptoUtils } from "@/libs/utils/cryptoUtils";
export default {
  mixins: [GenericMixin, RolMixin, SettingsMixin],
  data() {
    return {
      isExternal: null,
      allItems: [
        {
          title: "Usuarios",
          icon: "user-tie",
          path: Constant.SECTION_USERS,
          visible: false,
        },
        {
          title: "Métricas",
          icon: "tachometer-alt",
          path: Constant.SECTION_METRICS,
          visible: false,
        },
        {
          title: "Facturación",
          icon: "cash-register",
          active: false,
          visible: false,
          items: [
            {
              title: "Comprobantes",
              icon: "file-invoice",
              path: Constant.SECTION_VOUCHERS,
              visible: false,
            },
            {
              title: "Remitos",
              icon: "receipt",
              path: Constant.SECTION_REMITOS,
              visible: false,
            },
            {
              title: "Ordenes de venta",
              icon: "file-invoice",
              path: Constant.SECTION_SALE_ORDER,
              visible: false,
            },
            {
              title: "Cobros",
              icon: "money-check",
              path: Constant.SECTION_CHARGES,
              visible: false,
            },
            {
              title: "Clientes",
              icon: "users",
              path: Constant.SECTION_CLIENTS,
              visible: false,
            },
            {
              title: "Receptores",
              icon: "inbox",
              path: Constant.SECTION_RECEIVERS,
              visible: false,
            },
            {
              title: "Emisores",
              icon: "inbox",
              path: Constant.SECTION_EMITTERS,
              visible: false,
            },
            {
              title: "Lista de precios",
              icon: "circle",
              path: Constant.SECTION_PRICE_LIST,
              visible: false,
            },
          ],
        },
        {
          title: "Gastos",
          icon: "dollar",
          active: false,
          visible: false,
          items: [
            {
              title: "Comprobantes",
              icon: "file-invoice",
              path: Constant.SECTION_SPENTS,
              visible: false,
            },
            {
              title: "Remitos",
              icon: "file-invoice",
              path: Constant.SECTION_PURCHASE_REMITOS,
              visible: false,
            },
            {
              title: "Ordenes de compra",
              icon: "file-invoice",
              path: Constant.SECTION_PURCHASE_ORDER,
              visible: false,
            },
            {
              title: "Plantillas",
              icon: "file-invoice",
              path: Constant.SECTION_SPENT_TEMPLATES,
              visible: false,
            },
            {
              title: "Pagos",
              icon: "money-check",
              path: Constant.SECTION_SPENT_PAYMENTS,
              visible: false,
            },
            {
              title: "Solicitud de pago",
              icon: "file-invoice",
              path: Constant.SECTION_PAYMENT_ORDER,
              visible: false,
            },
            {
              title: "Proveedores",
              icon: "circle",
              path: Constant.SECTION_SUPPLIERS,
              visible: false,
            },
          ],
        },
        /*{
          title: "Integraciones",
          icon: "exchange-alt",
          path: Constant.SECTION_INTEGRATIONS,
          visible: false,
        },*/
        {
          title: "Productos",
          icon: "box",
          active: false,
          visible: false,
          items: [
            {
              title: "Producto",
              icon: "circle",
              path: Constant.SECTION_PRODUCTS,
              visible: false,
            },
            {
              title: "Rubros",
              icon: "circle",
              path: Constant.SECTION_CATEGORIES,
              visible: false,
            },
            {
              title: "Subrubros",
              icon: "circle",
              path: Constant.SECTION_SUBCATEGORIES,
              visible: false,
            },
            {
              title: "Tipos de producto",
              icon: "circle",
              path: Constant.SECTION_PRODUCT_TYPE,
              visible: false,
            },
          ],
        },
        {
          title: "Inventario",
          icon: "boxes-stacked",
          active: false,
          visible: false,
          only_visible_with_stock: true,
          items: [
            { title: "Stock", icon: "archive", path: Constant.SECTION_STOCKS, visible: false },
            { title: "Operaciones", icon: "", path: Constant.SECTION_INVENTORY_OPERATION, visible: false },
            { title: "Historial de stock", icon: "clock", path: Constant.SECTION_HISTORIAL_STOCKS, visible: false },
            { title: "Depositos", icon: "building", path: Constant.SECTION_WAREHOUSES, visible: false },
            { title: "Operarios", icon: "phone", path: Constant.SECTION_OPERATORS, visible: false },
          ],
        },
        {
          title: "Producción",
          icon: "industry",
          active: false,
          visible: false,
          only_visible_with_stock: true,
          items: [
            {
              title: "Órdenes de Producción",
              icon: "clipboard-list",
              path: Constant.SECTION_PRODUCTION_ORDERS,
              visible: false,
            },
            {
              title: "Fórmulas",
              icon: "flask",
              path: Constant.SECTION_FORMULAS,
              visible: false,
            },
            {
              title: "Líneas de Producción",
              icon: "conveyor-belt",
              path: Constant.SECTION_PRODUCTION_LINES,
              visible: false,
            },
            {
              title: "Recursos",
              icon: "tools",
              path: Constant.SECTION_RESOURCES,
              visible: false,
            },
            {
              title: "Materias Primas",
              icon: "box-open",
              path: Constant.SECTION_RAW_MATERIALS,
              visible: false,
            },
            {
              title: "Estados Internos",
              icon: "tasks",
              path: Constant.SECTION_INTERNAL_STATES,
              visible: false,
            },
          ],
        },

        {
          title: "Tesoreria",
          icon: "landmark",
          active: false,
          visible: false,
          items: [
            {
              title: "Cuentas",
              icon: "circle",
              path: Constant.SECTION_MONEY_ACCOUNTS,
              visible: false,
            },
            {
              title: "Cheques",
              icon: "circle",
              path: Constant.SECTION_CHECKS,
              visible: false,
            },
            {
              title: "Movimientos",
              icon: "circle",
              path: Constant.SECTION_TESORERIA_MOVEMENTS,
              visible: false,
            },
            {
              title: "Conciliación bancaria",
              icon: "circle",
              path: Constant.SECTION_CONCILIACIONES_BANCARIAS,
              visible: false,
            },
            {
              title: "Reglas de conciliación",
              icon: "circle",
              path: Constant.SECTION_CONCILIACION_REGLAS,
              visible: false,
            },
            {
              title: "Plantillas",
              icon: "circle",
              path: Constant.SECTION_TESORERIA_MOVEMENT_TEMPLATES,
              visible: false,
            },
            {
              title: "Tipo de comprobantes",
              icon: "circle",
              path: Constant.SECTION_TESORERIA_CLASE_COMPROBANTE,
              visible: false,
            },
          ],
        },
        {
          title: "Contabilidad",
          icon: "scale-balanced",
          active: false,
          visible: false,
          items: [
            {
              title: "Plan de Cuentas",
              icon: "circle",
              path: Constant.SECTION_ACCOUNTS,
              visible: false,
            },
            {
              title: "Libro Diario",
              icon: "circle",
              path: Constant.SECTION_ASIENTOS,
              visible: false,
            },
            {
              title: "Plantillas de Asientos",
              icon: "circle",
              path: Constant.SECTION_ASIENTO_TEMPLATES,
              visible: false,
            },
            {
              title: "Libro Mayor",
              icon: "circle",
              path: Constant.SECTION_REPORT_MAYOR,
              visible: false,
            },
            {
              title: "Sumas y Saldos",
              icon: "circle",
              path: Constant.SECTION_REPORT_SUMAS_Y_SALDOS,
              visible: false,
            },
            {
              title: "Estado de Resultados",
              icon: "circle",
              path: Constant.SECTION_REPORT_ESTADO_RESULTADOS,
              visible: false,
            },
            {
              title: "Resultados Mensuales",
              icon: "circle",
              path: Constant.SECTION_REPORT_RESULTADOS_MENSUALES,
              visible: false,
            },
            {
              title: "Situación Patrimonial",
              icon: "circle",
              path: Constant.SECTION_REPORT_BALANCE,
              visible: false,
            },
            {
              title: "Ejercicios y Períodos",
              icon: "circle",
              path: Constant.SECTION_EJERCICIOS,
              visible: false,
            },
            {
              title: "Configuración Contable",
              icon: "circle",
              path: Constant.SECTION_CONTABILIDAD,
              visible: false,
            },
          ],
        },
        {
          title: "Logística",
          icon: "truck",
          active: false,
          visible: false,
          only_visible_with_stock: true,
          items: [
            {
              title: "Viajes",
              icon: "user-tie",
              path: Constant.SECTION_SHIPPING,
              visible: false,
            },
            {
              title: "Tarifas",
              icon: "user-tie",
              path: Constant.SECTION_RATE,
              visible: false,
            },

            {
              title: "Zonas",
              icon: "user-tie",
              path: Constant.SECTION_ZONE,
              visible: false,
            },
            {
              title: "Transportes",
              icon: "user-tie",
              path: Constant.SECTION_CARRIER,
              visible: false,
            },
          ],
        },
        {
          title: "Reportes",
          icon: "file-excel",
          active: false,
          visible: false,
          items: [
            {
              title: "Cta. Cte. clientes",
              icon: "file-invoice",
              path: Constant.SECTION_REPORTE_CTA_CTE_CLIENT,
              visible: false,
            },
            {
              title: "Cta. Cte. proveedores",
              icon: "file-invoice",
              path: Constant.SECTION_REPORTE_CTA_CTE_SUPPLIER,
              visible: false,
            },
            {
              title: "Cobranzas pendientes",
              icon: "file-invoice",
              path: Constant.SECTION_REPORTE_CLIENT_PENDING_CHARGE,
              visible: false,
            },
            {
              title: "Pagos pendientes",
              icon: "file-invoice",
              path: Constant.SECTION_REPORTE_SUPPLIER_PENDING_SPENT,
              visible: false,
            },
            {
              title: "Ventas",
              icon: "file-invoice",
              path: Constant.SECTION_REPORTE_SALES_BY_PRODUCT,
              visible: false,
            },
            {
              title: "Compras",
              icon: "file-invoice",
              path: Constant.SECTION_REPORTE_PURCHASE,
              visible: false,
            },
            {
              title: "Ordenes de venta",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_SALE_ORDER,
              visible: false,
            },
            {
              title: "Ordenes de compra",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_PURCHASE_ORDER,
              visible: false,
            },
            {
              title: "Libro IVA digital",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_IVA_DIGITAL,
              visible: false,
            },
            {
              title: "Retenciones",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_RETENTIONS,
              visible: false,
            },
            {
              title: "Percepciones",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_PERCEPTIONS,
              visible: false,
            },
            {
              title: "Agentes de recaudacion",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_AGENTES_RECAUDACION,
              visible: false,
            },
            {
              title: "Comisiones por vendedor",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_SALESMAN_COMMISSION,
              visible: false,
            },
            {
              title: "Centro de costos",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_COSTS_CENTERS,
              visible: false,
            },
            {
              title: "Resultados por Tesorería",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_RESULTADOS,
              visible: false,
            },
            {
              title: "Cash Flow de Cheques",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_CASHFLOW_CHEQUES,
              visible: false,
            },
            {
              title: "Ponderación de cobros",
              icon: "file-invoice",
              path: Constant.SECTION_PONDERACION_CHARGE,
              visible: false,
            },
            {
              title: "Movimientos de stock",
              icon: "file-invoice",
              path: Constant.SECTION_REPORT_STOCK_MOVEMENTS,
              visible: false,
              only_visible_with_stock: true,
            },
          ],
        },

        {
          title: "Administrar",
          icon: "cog",
          active: false,
          visible: false,
          items: [
            {
              title: "Tipos de proveedor",
              icon: "cogs",
              path: Constant.SECTION_SUPPLIER_TYPE,
              visible: false,
            },
            {
              title: "Tipos de cliente",
              icon: "cogs",
              path: Constant.SECTION_CLIENT_TYPE,
              visible: false,
            },

            {
              title: "Zonas de cliente",
              icon: "cogs",
              path: Constant.SECTION_CLIENT_ZONE,
              visible: false,
            },
            {
              title: "Vendedores",
              icon: "user-tie",
              path: Constant.SECTION_SALESMAN,
              visible: false,
            },
            {
              title: "Centros de costos",
              icon: "user-tie",
              path: Constant.SECTION_COSTS_CENTERS,
              visible: false,
            },
            {
              title: "Conceptos",
              icon: "label",
              path: Constant.SECTION_CONCEPTOS,
              visible: false,
            },
            // {
            //   title: "Subcentros de costos",
            //   icon: "user-tie",
            //   path: Constant.SECTION_SUB_COSTS_CENTERS,
            //   visible: false,
            // },
            {
              title: "Colaboradores",
              icon: "user-tie",
              path: Constant.SECTION_EMPLOYEES,
              visible: false,
            },

            {
              title: "Roles",
              icon: "user-cog",
              path: Constant.SECTION_ROLES,
              visible: false,
            },
            {
              title: "Logs de actividad",
              icon: "cogs",
              path: Constant.SECTION_LOGS,
              visible: false,
            },
            {
              title: "Configuración",
              icon: "cogs",
              path: Constant.SECTION_SETTINGS,
              visible: false,
            },
          ],
        },
      ],
      items: [],
      right: null,
      expandMenu: this.$store.state.sidebar.open ? true : false,
      isMobile: false,
      show: true,
    };
  },
  mounted() {
    this.loadSideBarExternal();
  },
  watch: {},
  methods: {
    handleExpandMenu(value) {
      if (this.$store.state.sidebar.mini) {
        this.$store.commit("setOpenSidebar", {
          expand_on_hover: true,
        });
      }
    },
    close() {},
    loadSideBarExternal() {
      this.items = this.getItemsAvailable();
    },
    getItemsAvailable() {
      let itemsAvailable = [...this.allItems];
      itemsAvailable.forEach((item) => {
        if ("items" in item) {
          let any_visible = false;
          item.items.forEach((sub_item) => {
            sub_item.visible = sub_item.path in this.roles && this.roles[sub_item.path].sidebar;

            //Si el sub-item solo es visible con stock y no es una empresa de productos, se oculta
            if (sub_item.only_visible_with_stock != undefined && sub_item.only_visible_with_stock && !this.isProductCompany()) {
              sub_item.visible = false;
            }

            if (sub_item.visible) any_visible = true;
          });
          item.visible = any_visible;
        } else {
          item.visible = item.path in this.roles && this.roles[item.path].sidebar;
        }

        //Si el item solo es visible con stock y no es una empresa de productos, se oculta
        if (item.only_visible_with_stock != undefined && item.only_visible_with_stock && !this.isProductCompany()) {
          item.visible = false;
        }
      });
      return itemsAvailable;
    },
  },
};
</script>
